"use client";

import { useEffect, useState } from "react";

/**
 * True once mounted in the browser — gates browser-only rendering (portals,
 * local-timezone formatting) so SSR and hydration agree.
 */
export function useMounted(): boolean {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  return mounted;
}
